import "./base";

import "../modernizr";
import "./platform_detection";
import "./splide";
import "./modals";

import ChangeAccountDetailsController from "./controllers/change_account_details_controller";
import GenerateParentLettersController from "./controllers/generate_parent_letters_controller";
import ClassCodeController from "./controllers/class_code_controller";
import EmptyController from "./controllers/empty_controller";
import ValidController from "./controllers/valid_controller";
import GeneratePdfController from "./controllers/generate_pdf_controller";

Stimulus.register("change-account-details", ChangeAccountDetailsController);
Stimulus.register("generate-parent-letters", GenerateParentLettersController);
Stimulus.register("class-code", ClassCodeController);
Stimulus.register("empty", EmptyController);
Stimulus.register("valid", ValidController);
Stimulus.register("generate-pdf", GeneratePdfController);
